import Class from '@/Class';

export default class ControlTuple extends Class {

    public control: JQuery<HTMLElement>;
    public isDisposable: boolean;

    constructor($control: JQuery) {
        super();

        this.control = $control;
        this.isDisposable = true;
    }
}